import {Component, OnInit} from '@angular/core';
import { UserService } from '@app/core/services/user.service';
import {EntityType} from '@lib/models/entity/entity-type';

@Component({
  selector: 'app-team-videos',
  templateUrl: './team-videos.component.html',
  styleUrls: ['./team-videos.component.scss']
})

export class TeamVideosComponent implements OnInit {

  public entityType = EntityType.Team;

  constructor( public userService: UserService ) { }

  ngOnInit() { }
}
